import classNames from "classnames";
import React from "react";
import { MessageTheme } from "types";

interface MessageProps {
  theme?: MessageTheme;
}

export const Message: React.FC<MessageProps> = ({
  theme = MessageTheme.status,
  children,
}) => (
  <div role="alert" className={classNames("message", [theme && `is-${theme}`])}>
    {children}
  </div>
);
